import { Component } from "@angular/core";
import { DataService } from "../../services/data.service";
import { BusinesLogicService } from "../../services/business-logic.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "app-cancel",
  templateUrl: "./cancel.component.html",
  styleUrls: ["./cancel.component.css"]
})
export class CancelComponent {

  private destroy$ = new Subject();

  constructor(
    private _data: DataService,
    private _blogic: BusinesLogicService
  ) { }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /* Cancel action */
  public cancel(): void {
    var params: object;
    if (
      this._data.configuration["activeSupervisor"] &&
      this._data.selectedTurn != null
    ) {
      params = {
        turn_id: this._data.selectedTurn["id"],
        queue_id: this._data.selectedTurn["queue_id"],
        desk_id: this._data.selectedTurn["desk"],
        deskuser: this._data.session["username"],
        deskoperator: this._data.session["operator"]
      };
    } else {
      params = {
        turn_id: this._data.turn["id"],
        queue_id: this._data.turn["queue_id"],
        desk_id: this._data.session["desk"],
        deskuser: this._data.session["username"],
        deskoperator: this._data.session["operator"]
      };
    }



    this._blogic.cancelOperation(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this._data.actionContainer = 0;
        this._data.closeTurn();
        this._data.selectedTurn = null;

        if (this._data.session["autosupervisor"] && this._data.session["queuemode"] == 'Q') {
          let params2: object = {
            desk_id: this._data.session["desk"],
            status: "I",
            deskuser: this._data.session["username"],
            deskoperator: this._data.session["operator"],
          };

          this._blogic.deskNotify(params2)
            .pipe(takeUntil(this.destroy$))
            .subscribe();
        }
      });
  }
}
